// The exact ratio the server's fold uses (backend/pkg/positions/fold.go
// ratioFloat). The client cost-basis fold that lived here was removed in
// realtime stage 1 (wiki/plans/2026-11-04-realtime-stage1-design.md): the
// server builds every Holders / Top traders row; the page only values the
// server's valued_* units at the newest mark (lib/liveHolders unrealizedAt,
// lib/livePortfolioValue).

const SCALE = 10n ** 18n

/** n / d as a float, exact to ~1e-18 relative (fold.go ratioFloat). */
export function ratio(n: bigint, d: bigint): number {
  if (d === 0n) return 0
  const neg = n < 0n !== d < 0n
  const a = n < 0n ? -n : n
  const b = d < 0n ? -d : d
  const whole = a / b
  const frac = Number(((a % b) * SCALE) / b) / 1e18
  const v = Number(whole) + frac
  return neg ? -v : v
}
